<template>
	<div class="row">
		<div class="col-sm-6">
			<div class="box">
				<div class="box-header">
					<h2 class="box-title">I need help with the <strong>simulator</strong></h2>
				</div>
				<div class="box-body">
					<p>Contact the simulator support team</p>

					<ul class="contact-list nolist">
						<!-- <li><i class="fa fa-fw fa-user"></i> Simulator Support </li> -->
						<li><i class="fa fa-fw fa-envelope"></i> <a href="mailto:ferment.simulator@awri.com.au">ferment.simulator@awri.com.au</a></li>
						<li><i class="fa fa-fw fa-phone"></i> <a href="tel:0883130891">08 8313 0891</a></li>
					</ul>
				</div>
			</div>
		</div>
		<div class="col-sm-6">
			<div class="box">
				<div class="box-header">
					<h2 class="box-title">I need help with a <strong>ferment</strong></h2>
				</div>
				<div class="box-body">
					<p>Contact the AWRI Helpdesk</p>

					<ul class="contact-list nolist">
						<li><i class="fa fa-fw fa-globe"></i> <a href="http://www.awri.com.au/industry_support/helpdesk/">Helpdesk Website</a></li>
						<li><i class="fa fa-fw fa-envelope"></i> <a href="mailto:helpdesk@awri.com.au">helpdesk@awri.com.au</a></li>
						<li><i class="fa fa-fw fa-phone"></i> <a href="tel:0883136600">08 8313 6600</a></li>
					</ul>
				</div>
			</div>
		</div>
		<div class="col-sm-12">
			<div class="alert alert-info">
				<span class="entypo-info-circled"></span>
				Remember you can save and attach your ferment data as an Excel file. This may help us help you as quickly as possible
			</div>
		</div>
		<div class="col-sm-12">
			<div class="box">
				<div class="box-header">
					<h2 class="box-title">Other resources</h2>
				</div>
				<div class="box-body">
					<ul class="nav nav-list nav-list-half">
						<li><a href="http://www.awri.com.au/industry_support/winemaking_resources/calculators/" target="_blank"><i class="fa fa-external-link"></i> AWRI Winemaking Calculators</a></li>
						<li><a href="http://www.awri.com.au/information_services/fact-sheets/" target="_blank"><i class="fa fa-external-link"></i> AWRI Fact Sheets</a></li>
						<li><a href="http://www.awri.com.au/industry_support/winemaking_resources/wine_fermentation/" target="_blank"><i class="fa fa-external-link"></i> AWRI Fermentation Info</a></li>
						<li><a href="http://www.awri.com.au/commercial_services/analytical_services/" target="_blank"><i class="fa fa-external-link"></i> AWRI Lab Analysis</a></li>
						<li><a href="http://www.awri.com.au/information_services/library-services-to-levy-payers/" target="_blank"><i class="fa fa-external-link"></i> AWRI Library</a></li>					</ul>
					</div>
				</div>
			</div>
		</div>

	</template>

	<script>
	import { site } from 'vx/getters'
	import { App as AppActions } from 'vx/actions'
	import Alert from 'utils/alert'
	import Notify from 'utils/notify'

	export default {
		vuex: {
			getters: {
				site
			},

			actions: {
				setTitle: AppActions.title
			}
		},

		route: {
			activate() {
				this.$dispatch('loading');
			},

			data() {
				this.$dispatch('loaded');
			}
		},

		data() {
			return {
				tank_group_id: null,
				search: ''
			}
		},

		ready() {
			this.setTitle('Contact');
		}
	};
	</script>



// WEBPACK FOOTER //
// index.vue?a9553142